import React from 'react';
import { Card } from '@mui/material';

const BgImage = (props) => {

    return (

        <Card
            sx={{
                width: {
                    xs: "100%",
                    md: "80%"
                },
                height: {
                    xs: "auto",
                    xl: "calc(100vh - 80px)"
                },
            }}
            elevation={0}
        >
            <video
                poster='https://tirefax.s3.us-west-2.amazonaws.com/videos/thumbnail.png'
                preload="auto"
                //playsInline
                width="100%" //height="100%"
                //autoPlay
                //muted
                loop
                controls="controls"

            >
                <source src="https://tirefax.s3.us-west-2.amazonaws.com/videos/tirefax_720.mp4" type="video/mp4" />
            </video>
        </Card>
    )
}

export default BgImage;